var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailStackMissIcon = function SvgNewcsDashboardCrashanalysisIssuedetailStackMissIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_stack_miss_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M865 253h16v16h-16z",
    "data-name": "\\u77E9\\u5F62 474"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_stack_miss_icon_svg__a)",
    transform: "translate(-865 -253)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M866.133 268.037a.6.6 0 0 1 0-.849l12.9-12.9a.6.6 0 0 1 .848 0 .6.6 0 0 1 0 .849l-12.9 12.9a.6.6 0 0 1-.425.175.6.6 0 0 1-.423-.175m2.151-.037 1.167-1.167h8.356v-8.167h-.189l.98-.98.409.4v8.75a1.185 1.185 0 0 1-1.2 1.167Zm-1.277-2.968v-9.866a1.185 1.185 0 0 1 1.2-1.166h6.6l1.641 1.595-2.24 2.24v-2.669h-6v8.669l-1.2 1.2Zm6-.532h-1.22l1.167-1.167h.055v1.166Zm-3.6-3.5v-1.166h2.8L871.038 261Z",
    "data-name": "\\u8054\\u5408 76"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailStackMissIcon;